import { render, staticRenderFns } from "./GdprField.vue?vue&type=template&id=94b24172"
import script from "./GdprField.vue?vue&type=script&lang=js"
export * from "./GdprField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports